export function getErrorMessage(error: string | Error | undefined): string {
  if (error === undefined) {
    return '';
  } else if (typeof error === 'string') {
    return error;
  }

  return error.message;
}
